import { Auth, API, graphqlOperation } from 'aws-amplify'
import { listUsers } from "../../graphql/queries";

const state = {
    userAppID: '',
    user: {}
};

const getters = {
    getUser: (state) => state.user,
    getAppUserID: (state) => state.userAppID
};

const actions = {
    async fetchUser({ commit }) {
        await Auth.currentAuthenticatedUser()
            .then(async user => {
                commit('setUser', user.attributes);
                await API.graphql(graphqlOperation(listUsers, {
                    filter: {
                        cognitoID: {
                            eq: user.attributes.sub
                        }
                    }
                })).then(response => {
                    const appUserID = response.data.listUsers.items[0].id;
                    commit('setOrgID', response.data.listUsers.items[0].orgID)
                    commit('setAppUserID', appUserID);
                })
            })
            .catch((error) => console.log(error));
    }
};

const mutations = {
    setUser: (state, user) => (state.user = user),
    setAppUserID: (state, appUserID) => (state.userAppID = appUserID)
};

export default {
    state,
    getters,
    actions,
    mutations
}